import "./index.scoped.css";

function ServiceDetail(props) {
    if (props.data[0]["exception"] != "exception") {
        return (
            <div className="detail__wrapper">
                {props.data.map((item, key) => (
                    <details className="service__detail" key={key}>
                        <summary>
                            <h3>{item.title}</h3>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                                viewBox="0 0 20 20"
                                fill="#16122B"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </summary>

                        <div className="detail__info hide">
                            <p className="info_description">
                                {item.desciption.map((text, key) => (
                                    <p key={key}>{text}</p>
                                ))}
                            </p>

                            <div className="docs__block">
                                <p className="__primary">
                                    Документы, которые необходимо предоставить:
                                </p>

                                <div className="docs__list">
                                    {item.docs.map((text, key) => (
                                        <p key={key}>{text}</p>
                                    ))}
                                </div>
                            </div>

                            <p className="additional__info">
                                {item.additional.map((text, key) => (
                                    <p key={key}>{text}</p>
                                ))}
                            </p>

                            <div className="tariffs__block">
                                <p className="__primary">Тариф:</p>
                                <p className="tariffs__info">{item.tariff}</p>
                            </div>
                        </div>
                    </details>
                ))}
            </div>
        );
    } else {
        return (
            <div className="detail__wrapper">
                <details className="service__detail" open>
                    <summary>
                        <h3>Что такое доверенность</h3>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            viewBox="0 0 20 20"
                            fill="#16122B"
                        >
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </summary>

                    <div className="detail__info">
                        <div className="info_description">
                            <p>Представляет собой письменно оформленное полномочие, которым одно лицо (доверитель) наделяет другое лицо (поверенного) для представления своих интересов перед третьими лицами.</p>
                            <p>Доверенность является односторонней сделкой, для её совершения необходимо только волеизъявление доверителя. Доверитель самостоятельно определяет срок доверенности. Законодательно этот срок не ограничен, однако если его не указать, доверенность действует один год с даты её удостоверения нотариусом.</p>
                            <p>акже доверителю необходимо решить, будет ли доверенность содержать право на передоверие. Это означает возможность поверенного передать полномочия полностью или частично другому лицу.</p>
                        </div>

                        <div className="docs__block">
                            <p className="__primary">
                                Документы, которые необходимо предоставить:
                            </p>
                            <div className="docs__list">
                                <p>— паспорт;</p>
                            </div>
                        </div>

                        <div className="additional__info ">
                            <p>Также необходимо сообщить сведения о человеке, на которого выдается доверенность (ФИО, адрес регистрации) и, соответственно, информацию о том, что именно доверяется сделать поверенному. Если доверенность касается прав на недвижимое имущество, необходимо сообщить точный адрес этого имущества.
                            </p>
                        </div>
                    </div>
                </details>

                <div className="price__list">
                    {props.data[0].data.map((item, key) => (
                        <div className="position" key={key}>
                            <p>{item.title.slice(0, -1)}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default ServiceDetail;